import FaqPage from '@src/quince-site-integrated/src/templates/FaqPage'

import { PageTemplateProps } from './page-templates.types'

export default function FaqPageTemplate({ pageData }: PageTemplateProps) {
  return <FaqPage data={pageData.faqPage} />
}
